import { Backdrop, Button, CircularProgress, Container, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Context } from "../../App";

export default function UserCompteForm({onLogin}) {
    const { region, isConnected } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);
    const [eglises, setEglises] = React.useState([]);

    const [genre, setGenre] = React.useState('Mr');
    const [nom, setNom] = React.useState('');
    const [prenom, setPrenom] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [tel, setTel] = React.useState('');
    const [voie, setVoie] = React.useState('');
    const [zip_code, setZipCode] = React.useState('');
    const [ville, setVille] = React.useState('');
    const [adresse_complement, setAdresseComplement] = React.useState('');
    const [eglise, setEglise] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [passwordError, setPasswordError] = React.useState('');
    const [msg, setMsg] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if(password.length < 8) {
            setPasswordError('Le mot de passe doit contenir au moins 8 caractères');
            return;
        } else if (password !== confirmPassword) {
            setPasswordError('Les mots de passe ne correspondent pas');
            return;
        } else {
            setPasswordError('');
            setLoading(true);

            fetch(`${process.env.REACT_APP_API_URL}/public/donateur`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}`
                },
                body: JSON.stringify({
                    genre,
                    nom,
                    prenom1: prenom,
                    mail,
                    tel,
                    password,
                    voie,
                    zip_code,
                    ville,
                    adresse_complement,
                    region: !!region ? [region] : [],
                    eglise
                }),
            })
            .then(async response => {
                if (response.status === 400) {
                    const json = await response.json();
                    setMsg(json.message || 'Erreur lors de l\'enregistrement');
                }else if (response.status === 200) {
                    const token = response.headers.get('x-auth-token');
                    if (token) localStorage.setItem('token', token);
                    const json = await response.json();
                    localStorage.setItem('user', JSON.stringify(json.donateur));
                    onLogin()
                }else setMsg('Erreur lors de l\'enregistrement');
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.error('Erreur lors de l\'inscription :', error);
                alert('Une erreur est survenue. Veuillez réessayer plus tard.');
            });
        }
    }

    useEffect(()=>{
        if (region) {
            fetch(`${process.env.REACT_APP_API_URL}/public/eglises/by?` + new URLSearchParams({ region: region, type:'église' }).toString(), { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setEglises(data);
            })
            .catch(error => console.error('Error fetching eglises:', error));
        }
    },[region]);

    return <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:2, minWidth: '400px' }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je m'inscris</Typography>

        <TextField fullWidth select label="Genre" variant="outlined" value={genre} required
        onChange={(e) => setGenre(e.target.value)} slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
            <option disabled value="">Sélectionnez un genre</option>
            <option value="Mr">Monsieur</option>
            <option value="Mme">Madame</option>
        </TextField>

        <TextField fullWidth label="Nom" variant="outlined" value={nom} required
        onChange={(e) => setNom(e.target.value)} />
        <TextField fullWidth label="Prénoms" variant="outlined" value={prenom} required
        onChange={(e) => setPrenom(e.target.value)} />

        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required type="email"
        onChange={(e) => setMail(e.target.value)} />

        <TextField fullWidth type="phone" label="GSM" variant="outlined" value={tel} 
        onChange={(e) => setTel(e.target.value)} />

        {region && <TextField fullWidth label="Eglise" variant="outlined" value={eglise} 
        onChange={(e) => setEglise(e.target.value)} select slotProps={{ select: {native: true}, inputLabel:{shrink: true} }} sx={{ mb: 2 }}>
            <option key={0} value="">Sélectionnez une église (optionel)</option>
            {eglises.sort((a,b)=>a.nom>b.nom?1:-1).map((eglise) => (
                <option key={eglise.id} value={eglise.number}>{eglise.nom}</option>
            ))}
        </TextField>}

        <Typography variant="h6" sx={{ mt: 2 }}>Adresse</Typography>
        <TextField fullWidth label="Numéro et nom de la voie" variant="outlined" value={voie}
        onChange={(e) => setVoie(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Complément d'adresse" variant="outlined" value={adresse_complement}
        onChange={(e) => setAdresseComplement(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Code postal" variant="outlined" value={zip_code} required
        onChange={(e) => setZipCode(e.target.value)} sx={{ mb: 2 }} />
        <TextField fullWidth label="Ville" variant="outlined" value={ville} required
        onChange={(e) => setVille(e.target.value)} sx={{ mb: 2 }} />

        <Typography variant="h6" sx={{ mt: 2 }}>Mot de passe</Typography>
        <TextField fullWidth type="password" label="Mot de passe" variant="outlined" required
        onChange={(e) => setPassword(e.target.value)} />
        <TextField fullWidth type="password" label="Confirmer le mot de passe" variant="outlined" required error={!!passwordError}
        helperText={passwordError} onChange={(e) => setConfirmPassword(e.target.value)} sx={{ mb: 4 }} />

        <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2}}>Enregistrer</Button>

        <Backdrop open={loading}><CircularProgress/></Backdrop>

    </Container>
}